// extracted by mini-css-extract-plugin
module.exports = {"outerFrame":"SnackbarHelper__outerFrame___1jF5g"};